import { FC } from 'react';
import { AllieText } from '../../../../../components';
import { ProducedRateProps } from './ProducedRate.types';
import { AllieCaretDownOutlineIcon, AllieCaretUpOutlineIcon } from '../../../../../styling/icons';
import { ContainerProducedRate } from './ProducedRate.styles';

export const ProducedRate: FC<ProducedRateProps> = ({ produced, rate, showArrow }) => {
  return (
    <ContainerProducedRate>
      <AllieText type="body2" weight={600} className="label center">
        {produced}
      </AllieText>
      {showArrow && (rate ?? 0) > 0 && <AllieCaretUpOutlineIcon color="success" />}
      {showArrow && (rate ?? 0) < 0 && <AllieCaretDownOutlineIcon color="danger" />}
    </ContainerProducedRate>
  );
};
